import { FC } from "react";
import { Stack, Title } from "@mantine/core";
import { QuestionnaireForm } from "../../features/questionnaire/QuestionnaireForm";
import { useTranslation } from "react-i18next";

interface Props {
  onSubmit: () => void;
}

export const QuestionnaireWiget: FC<Props> = ({ onSubmit }) => {
  const { t } = useTranslation();

  return (
    <Stack align="stretch" justify="center" gap="36px">
      <Title size={36}>{t("questionnaire")}</Title>
      <QuestionnaireForm onSubmit={onSubmit} />
    </Stack>
  );
};
